import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorComponent } from '../hyperkit';
import { TypographyComponent, TypographyVariant } from '@hyperkit';

@Component({
  selector: 'hunt-details-editor',
  imports: [CommonModule, EditorComponent, TypographyComponent],
  templateUrl: './hunt-editor.component.html',
  styleUrls: ['./hunt-editor.component.scss'],
})
export class HuntEditorComponent {
  @Input() public title = '';
  @Input() public variant: TypographyVariant = 'h4';
  
  @Input() public value: string = ''; 
  @Output() public valueChange = new EventEmitter<string>();  // Output to emit changes from the editor

  onEditorValueChange(updatedValue: string): void {
    this.valueChange.emit(updatedValue);  // Emit changes from the editor back to parent
  }
}
